import { Injectable, OnDestroy } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { NotificationsService } from 'angular2-notifications';
import { SService } from '../SayTS/s.service';
import { ErrorService } from '../SayTS/error.service';
import { NgxSmartModalService } from 'ngx-smart-modal';
import { SwUpdate } from '@angular/service-worker';
import { HttpClient } from '@angular/common/http';
import { filter } from 'rxjs';
import { environment } from 'src/environments/environment';


@Injectable({
  providedIn: 'root'
})
export class SharedService extends SService implements OnDestroy {

  public product: any = null //relicts
  public productWatch: any = null //relicts
  public previousUrl: string | null = null;
  public currentUrl: string | null = null;

  constructor(public route: ActivatedRoute, public router: Router, protected notifier: NotificationsService, protected modal: NgxSmartModalService,
    protected errorService: ErrorService, protected swUpdate: SwUpdate, private httpClient: HttpClient) {
    super(route, router, notifier, modal, errorService)

    this.currentUrl = this.router.url;

    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        this.previousUrl = this.currentUrl;
        this.currentUrl = event.urlAfterRedirects;
      });
  }

  /**
   * Report a caught error to the backend errorJs endpoint.
   * Fire-and-forget — does not block the caller, swallows its own errors.
   */
  reportError(error: any, context?: string): void {
    try {
      const payload = {
        verze_klient: environment.version,
        context: context || null,
        url: this.currentUrl,
        message: error?.message || String(error),
        stack: error?.stack || null,
        status: error?.status ?? null,
        statusText: error?.statusText || null,
        hideLoader: true
      };
      this.httpClient.post(`${environment.apiUrl}errorJs`, payload)
        .subscribe({ error: () => { } });
    } catch { }
  }
}